import { render } from "./downloads.vue?vue&type=template&id=59c2a82e&scoped=true"
import script from "./downloads.vue?vue&type=script&lang=js"
export * from "./downloads.vue?vue&type=script&lang=js"

import "./downloads.vue?vue&type=style&index=0&id=59c2a82e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c2a82e"]])

export default __exports__